"use strict";

import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import LinearRing from "ol/geom/LinearRing";
import Polygon from "ol/geom/Polygon";
import MultiPoint from "ol/geom/MultiPoint";
import MultiLineString from "ol/geom/MultiLineString";
import MultiPolygon from "ol/geom/MultiPolygon";
import GeometryCollection from "ol/geom/GeometryCollection";
import Circle from "ol/geom/Circle";

/**
 * @classdesc
 * Geometrie-Implementierung auf Basis der Openlayers Kartenbibliothek.
 *
 * @abstract
 * @class
 * @extends gc.gis.geom.GCGeometry
 * @memberof gc.gis
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Geometry} geometry
 */
gc.gis.geom.OLGeometry = function(geometry)
{
    gc.gis.geom.GCGeometry.call(this, geometry);
};
gc.gis.geom.OLGeometry.prototype = Object.create(gc.gis.geom.GCGeometry.prototype);

/**
 * @inheritDoc
 */
gc.gis.geom.OLGeometry.prototype.getCRS = function()
{
    return this._geom.get('__gc_crs');
};

/**
 * @inheritDoc
 */
gc.gis.geom.OLGeometry.prototype.setCRS = function(crs)
{
    this._geom.set('__gc_crs', crs);
    return this;
};

/**
 * Projeziert die Geometrie in das angegebene CRS.
 *
 * @method
 * @param {string} crs
 * @public
 */
gc.gis.geom.OLGeometry.prototype.project = function(crs)
{
	const tmp = this.getCRS();
    if (this.getCRS() && crs && this.getCRS().toUpperCase() !== crs.toUpperCase())
    {
        try
        {
	        this._geom.transform(this.getCRS(), crs);
	        this.setCRS(crs);
        }
        catch (e)
        {
	        gc.gis.iface.log.error(this,
                'Geometrie konnte nicht transformiert werden: Unbekanntes Quellkoordinatenreferenzsystem: "'+ tmp + '"');
        }

    }
};

/**
 * @inheritDoc
 */
gc.gis.geom.OLGeometry.prototype.getType = function ()
{
    if (this.getImpl() instanceof Point) {
        return gc.gis.geom.GCGeometryType.POINT;
    }
    else if (this.getImpl() instanceof LineString) {
        return gc.gis.geom.GCGeometryType.LINESTRING;
    }
    else if (this.getImpl() instanceof LinearRing) {
        return gc.gis.geom.GCGeometryType.LINEARRING;
    }
    else if (this.getImpl() instanceof Polygon) {
        return gc.gis.geom.GCGeometryType.POLYGON;
    }
    else if (this.getImpl() instanceof MultiPoint) {
        return gc.gis.geom.GCGeometryType.MULTIPOINT;
    }
    else if (this.getImpl() instanceof MultiLineString) {
        return gc.gis.geom.GCGeometryType.MULTILINE;
    }
    else if (this.getImpl() instanceof MultiPolygon) {
        return gc.gis.geom.GCGeometryType.MULTIPOLYGON;
    }
    else if (this.getImpl() instanceof GeometryCollection) {
        return gc.gis.geom.GCGeometryType.GEOMETRYCOLLECTION;
    }
    else if (this.getImpl() instanceof Circle) {
	    return gc.gis.geom.GCGeometryType.CIRCLE;
    }

    return undefined;
};

/**
 * @inheritDoc
 */
gc.gis.geom.OLGeometry.prototype.getExtent = function ()
{
    return this.getImpl().getExtent();
};
